import { useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@mui/material'

import { ReactComponent as Sliders } from '../../../assets/icons/sliders.svg'
import useTranslations from '../../../i18n/useTranslations'
import DrawerWrapper from '../../../ui/modules/DrawerWrapper'

import FiltersForm from './FiltersForm'

const FiltersDrawerView = ({
  onUpdateFilters,
  user,
  countries,
  filters,
  disabledFilterByStatusCode,
}) => {
  const t = useTranslations()

  const [isModalOpen, setIsModalOpen] = useState(false)

  const applyFilters = updatedFilters => {
    setIsModalOpen(false)
    const newFilters = { ...filters, ...updatedFilters }
    onUpdateFilters(newFilters)
  }

  return (
    <>
      <Button
        onClick={() => setIsModalOpen(true)}
        variant="text"
        size="small"
        startIcon={<Sliders />}
      >
        {t('noun:filters')}
      </Button>
      <DrawerWrapper isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <FiltersForm
          userCentres={user.centres}
          countries={countries}
          filters={filters}
          disabledFilterByStatusCode={disabledFilterByStatusCode}
          cancel={() => setIsModalOpen(false)}
          confirm={applyFilters}
        />
      </DrawerWrapper>
    </>
  )
}
FiltersDrawerView.propTypes = {
  onUpdateFilters: PropTypes.func.isRequired,
  user: PropTypes.shape({
    centres: FiltersForm.propTypes.userCentres,
  }).isRequired,
  countries: FiltersForm.propTypes.countries,
  filters: FiltersForm.propTypes.filters,
  disabledFilterByStatusCode: FiltersForm.propTypes.disabledFilterByStatusCode,
}

export default FiltersDrawerView
